import { useContext, useRef, useEffect } from 'react'
import { useDroppable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import FieldSortable from '../FieldSortable/FieldSortable'
import { observer } from 'mobx-react-lite'
import { Button } from 'antd'
import styles from './EditorCanvas.module.css'
import { BuilderContext } from '../../../store/store.Builder'
import ButtonSendForm from '../../../../../../components/ButtonSendForm/ButtonSendForm'
import { FormProvider, useForm } from 'react-hook-form'
import headersForms from '../../../../../../components/HeadersForms/headersForms'

const EditorCanvas = observer(() => {
  const builderContext = useContext(BuilderContext)

  const headerRef = useRef(null)

  const headerComponent = builderContext.styleForm.show_header
    ? headersForms.find(
        (header) =>
          header.value === builderContext.styleForm.header_type.typeHeader
      )?.component
    : null

  const methods = useForm()
  const { control } = methods
  const { formState } = methods
  const { errors } = formState

  const EditorCanvasRef = useRef(null)

  const { listeners, setNodeRef, transform, transition } = useDroppable({
    id: 'canvas_droppable',
    data: {
      parent: null,
      isContainer: true,
    },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const editorCanvas_style = {
    ...builderContext.styleForm.design,
  }

  const button_style = {
    ...builderContext.styleForm.design_button,
  }

  const handleCanvasClick = (event) => {
    if (
      event.target !== event.currentTarget &&
      !headerRef.current.contains(event.target)
    ) {
      return
    }

    console.log('Clic dans le canvas/Form ou dans le header spécifique')
    builderContext.setSelectedField(builderContext.styleForm, 'form')
  }

  const handleCanvasClickButtonSend = (event) => {
    console.log('Clic dans button')
    builderContext.setSelectedField(
      {
        design: builderContext.styleForm.design_button,
        id: builderContext.styleForm.url_code,
      },
      'button'
    )
  }

  return (
    <div className={styles.my_editorCanvas}>
      <header
        className={styles.header}
        onClick={handleCanvasClick}
        ref={headerRef}
      >
        {headerComponent}
      </header>

      <div />
      <div
        className={`${styles.editor__canvas} ${
          builderContext.selectedField?.url_code === builderContext.url_code
            ? styles.editor__canvas_with_border
            : ''
        }`}
        ref={setNodeRef}
        onClick={handleCanvasClick}
        style={editorCanvas_style}
        {...listeners}
      >
        <div onClick={handleCanvasClick} className="canvas-fields">
          {builderContext.fields &&
            builderContext.fields.map((field, index) => (
              <FieldSortable
                key={field.id}
                id={field.id}
                field={field}
                index={index}
              />
            ))}

          {builderContext.styleForm.show_send_btn && (
            <div
              onClick={handleCanvasClickButtonSend}
              className={`${styles.container__btn} ${
                builderContext.selectedField?.id ===
                  builderContext.styleForm.url_code &&
                builderContext.selectedField?.typeSelected === 'button'
                  ? 'selected__item'
                  : ''
              }`}
            >
              <ButtonSendForm style={button_style} text={'Envoyer'} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
})
export default EditorCanvas
